import { RH } from '@/constants/permissions'
import { userHasPermission } from '@/shared/lib/roleUtils'

/**
 * Alta manual en «Seleccionado»: la evaluación es obligatoria (SRH-309).
 *
 * Se sube al dar de alta o después. Mientras falte, el candidato queda marcado
 * como «Evaluación pendiente» y sin los efectos de la selección (ni correo, ni
 * aviso a RH, ni sale en contratación).
 */

export const ETIQUETA_EVALUACION_PENDIENTE = 'Evaluación pendiente'

/** Lo que se le dice a quien da de alta en Seleccionado sin subirla. */
export const AVISO_DE_ALTA_SIN_EVALUACION =
  'Sin la evaluación el candidato queda como «Evaluación pendiente»: no se le avisa que fue seleccionado ni se avisa a RH para contratarlo hasta que la subas.'

/** Quien da altas manuales o cierra la selección es quien puede subirla después. */
export const puedeSubirEvaluacion = (permisos: string[] | undefined): boolean => {
  const lista = permisos ?? []
  return (
    userHasPermission(RH.RECLUTAMIENTO_ALTA_MANUAL, lista) ||
    userHasPermission(RH.RECLUTAMIENTO_CERRAR_SELECCION, lista)
  )
}

/** Si el candidato está esperando su evaluación. */
export const tieneEvaluacionPendiente = (
  candidato?: { evaluationPending?: boolean | null } | null,
): boolean => candidato?.evaluationPending === true
